<!-- <div class="bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200"> -->
  
  <!-- Form Content Area -->
  <!-- <div class="px-6 py-5"> -->
    <div class="space-y-6">
      <app-dynamic-section
        *ngFor="let sec of layout.sections; let i = index"
        [section]="sec"
        [layout]="layout"
        [form]="form"
        [class.border-t]="i > 0"
        [class.pt-6]="i > 0"
        class="border-gray-200"
      ></app-dynamic-section>
    </div>
  <!-- </div> -->

<!-- </div> -->